module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_5-c3608d100925b5a73e078a5d3dfbc322.jpg";